import { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Envelope, Bell, Star, ChatCircleText, Lock } from '@phosphor-icons/react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../ModalContainer/ModelContainer'

import { getMessageTypeFilterOptions } from './helpers'

const ICONS_BY_TYPE = {
  email: <Envelope size={48} />,
  survey: <Star size={48} />,
  notification: <Bell size={48} />,
  sms: <ChatCircleText size={48} />,
}

const NewMessageTypeModal = ({
  communicateSMSAvailable,
  handleCancel,
  handleSubmit,
  shouldShowActivateSmsPanel,
}) => {
  const { t } = useTranslation(['organisation', 'common'])
  const navigate = useNavigate()

  const [selectedMessageType, setSelectedMessageType] = useState(null)

  const messageTypes = useMemo(
    () => getMessageTypeFilterOptions(communicateSMSAvailable, t),
    [communicateSMSAvailable, t],
  )
  return (
    <ModalContainer
      onClose={handleCancel}
      additionalClass={'new-message-type-modal'}
      headerTitle={t('organisation:communicationPortal.newMessageTypeModal.headerTitle')}
    >
      <div className="new-message-type-modal__body">
        <p>{t('organisation:communicationPortal.newMessageTypeModal.description')}</p>
        <div className={`new-message-type-modal__types`}>
          {messageTypes.map((type) => {
            const shouldDisableSmsOption = type.value === 'sms' && shouldShowActivateSmsPanel

            return (
              <div
                key={type.id}
                className={`new-message-type-modal__type ${
                  selectedMessageType && selectedMessageType.value === type.value ? 'selected' : ''
                } ${shouldDisableSmsOption ? 'disabled' : ''}`}
                onClick={() => {
                  if (shouldDisableSmsOption) {
                    return
                  }
                  setSelectedMessageType(type)
                }}
              >
                <div className="new-message-type-modal__type-icon">{ICONS_BY_TYPE[type.value]}</div>
                <div className="new-message-type-modal__type-name">{type.text}</div>
                {shouldDisableSmsOption && (
                  <button
                    className="activate-sms-button"
                    onClick={() => navigate('/dashboard/chat')}
                  >
                    <Lock size={25} weight="fill" />{' '}
                    {t(
                      'organisation:communicationPortal.newMessageTypeModal.activateAnnouncementNumber',
                    )}
                  </button>
                )}
              </div>
            )
          })}
        </div>
      </div>
      <div className="new-message-type-modal__footer">
        <button className="button button-gray" onClick={handleCancel}>
          {t('common:actions.cancel')}
        </button>
        <button
          className="button button-black"
          disabled={!selectedMessageType}
          onClick={() => handleSubmit(selectedMessageType)}
        >
          {t('organisation:shared.actions.create')}
        </button>
      </div>
    </ModalContainer>
  )
}

NewMessageTypeModal.propTypes = {
  communicateSMSAvailable: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleSubmit: PropTypes.func,
  shouldShowActivateSmsPanel: PropTypes.bool,
}

export default NewMessageTypeModal
